import 'react-toastify/dist/ReactToastify.min.css';
import React, { useCallback, useMemo } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer, toast } from 'react-toastify';
import { useConfigAxios } from '@area-restrita/client';

import { useAuthSessionStore } from './modules/authentication/stores/authSessionStore';
import queryClient from './config/queryClient';
import { apiConfig } from './config/api';
import Router from './router';
import { getCurrentRedirectPath } from './utils/redirect';

const redirectToSignIn = () => {
  const firstSegment = window.location.pathname
    .split('/')
    .filter(Boolean)
    .at(0);
  if (firstSegment === 'auth') return;

  const redirect = getCurrentRedirectPath();

  window.location.replace(
    `/auth/signin?redirect=${encodeURIComponent(redirect)}`,
  );
};

const App: React.FC = () => {
  const getAccessToken = useCallback(
    () => useAuthSessionStore.getState().session?.accessToken,
    [],
  );

  const onForbidden = useCallback(() => {
    useAuthSessionStore.getState().signOut();

    redirectToSignIn();
  }, []);

  const onUnauthorized = useCallback(() => {
    if (useAuthSessionStore.getState().session) {
      toast.error('Você não tem permissão para acessar este recurso.');
    } else {
      useAuthSessionStore.getState().signOut();

      redirectToSignIn();
    }
  }, []);

  useConfigAxios(
    useMemo(
      () => ({
        axiosConfigDefaults: apiConfig,
        getAccessToken,
        onForbidden,
        onUnauthorized,
      }),
      [getAccessToken, onForbidden, onUnauthorized],
    ),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <Router />
      <ToastContainer
        limit={8}
        theme="light"
        position="bottom-right"
        pauseOnHover
      />
    </QueryClientProvider>
  );
};

export default App;
